import { ForkEffect, fork } from 'redux-saga/effects';
import { institutionSaga } from './institutions';
import { reportSaga } from './reports/reports.saga';
import { childRegisterSaga } from 'store/childRegister/childRegister.saga';
import { authSaga } from './auth/auth.saga';
import { userSaga } from './user/user.saga';

export function* rootSaga(): IterableIterator<ForkEffect> {
  yield fork(institutionSaga);
  yield fork(reportSaga);
  yield fork(childRegisterSaga);
  yield fork(authSaga);
  yield fork(userSaga);
}
